import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '"观经典作品 传红色基因"征文比赛';

const route: RouteConfig = {
  path: '/20210122ZWBS',
  name: 'ZWBS',
  component: () => import('./Home.vue'),
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'First',
      component: () => import('./First.vue'),
      name: 'ZWBSFirst',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'Detail',
      component: () => import('./Detail.vue'),
      name: 'ZWBSDetail',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'ListPage',
      component: () => import('./ListPage.vue'),
      name: 'ZWBSListPage',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'SearchPage',
      component: () => import('./SearchPage.vue'),
      name: 'ZWBSSearchPage',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'User',
      component: () => import('./User.vue'),
      name: 'ZWBSUser',
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
